import React from 'react';
import moment from 'moment';
import { optionDateLabel } from '@features/RoomRateConfigurationWizard/FormSteps/ExtrasStep/Extras/Options/optionDateLabel';
import { useIsWindowWiderThan } from '@common/hooks';
import { gridTheme } from '@utils/grid';
import BlockSelectField from '@common/components/FormElements/BlockSelectField';

const optionsForPerDate = (options) => {
  const isMobile = !useIsWindowWiderThan(gridTheme.breakpoints.md);
  return options.map((option, index) => ({
    label: optionDateLabel(moment(option.startDate).format('MMM DD'), option.name, isMobile),
    value: index,
  }));
};

export const PerDate = ({ field, options }) => {
  return (
    <BlockSelectField
      onChange={(value) => {
        field.onChange(value);
      }}
      value={field.value}
      options={optionsForPerDate(options)}
    />
  );
};
